<script setup lang="ts">
  const props = defineProps({
    width: {
      type: String,
      default: '100%',
    },
    name: {
      type: String,
      default: 'Vaquejadas Ativas',
    },
    earn: {
      type: String,
      default: '4',
    },
    color: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: 'mdi-horse',
    },
    loading: {
      type: Boolean,
      default: false
    },
    isMoney: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ''
    }
  })
</script>
<template>
  <v-card class="ma-auto" elevation="5" :width="props.width" style="border-radius: 15px">
    <v-card variant="outlined" style="border-color: gray; border-radius: 15px">
      <v-card-text>
        <div class="d-flex align-items-center justify-space-between" style="position: relative">
          <div style="width: 100%; ">
            <h6 class="text-h6 text-lightText mb-1" style="font-weight: normal">
              {{ props.name }}
            </h6>
            <h4 class="text-h4">
              {{ $props.isMoney ? Number(props.earn).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : props.earn }}
            </h4>
            <h4 class="text-h4 d-flex align-center mb-0" style="position: absolute; top: 5px; right: 5px">
              <v-progress-circular v-if="props.loading" indeterminate :color="props.color" size="40" width="2" />
              <v-icon :class="'mr-1 text-' + props.color" :icon="props.icon" :style="{ fontSize: '25px' }" />
            </h4>
            <h6 style="font-weight: normal; font-size: 15px">
              {{ $props.subtitle }}
            </h6>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-card>
</template>
